import { isBrowser, parseQueryParamsToObject } from "./browser";

const viewScripts: string[] = ["1-13405", "1-14492", "1-16661", "1-17274", "1-17690"];
const applyScripts: string[] = ["3-13405", "3-14492", "3-16661", "3-17274", "3-17690"];

const generateScripts = (scripts: string[]) => {
    if (!isBrowser()) {
        return;
    }
    const queryParams = parseQueryParamsToObject(window.location.search);
    if (queryParams?.utm_source === "appcast") {
        scripts.forEach((scriptId: string) => {
            const scriptTag: HTMLScriptElement = document.createElement("script");
            scriptTag.src = `https://click.appcast.io/pixels/generic${scriptId}.js?ent=196`;
            document.head.appendChild(scriptTag);
        });
    }
};

const appCastJobView = () => {
    generateScripts(viewScripts);
};

const appCastJobApply = () => {
    generateScripts(applyScripts);
};

export {
    appCastJobView,
    appCastJobApply
};
